import Modal from "../../../../shared/components/UI/Modal/Modal";

interface SendedMailNotifyModalProps {
    isOpen: boolean;
    closeModal: () => void
}

const SendedMailNotifyModal = ({ isOpen, closeModal }: SendedMailNotifyModalProps) => {
    return (
        <Modal isOpen={isOpen} closeModal={closeModal} className="sended-mail-notify-modal">
            <h3 className="sended-mail-status">Письмо отправлено</h3>
            <p className="sended-mail-comment">Перейдите по ссылке из письма, чтобы подтвердить адрес электронной почты</p>
        </Modal>
    )
}
export default SendedMailNotifyModal;